import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectorBadgeComponent } from './connector-badge.component';
import { MatIconModule } from '@angular/material/icon';
import { ConnectorStatusPipesModule } from 'shared/connector-status-pipes/connector-status-pipes.module';
import { RouterModule } from '@angular/router';
import { CustomerPrivacyModule } from 'layout/customer-privacy/customer-privacy.module';
import { RoutedDialogWrapperModule } from 'shared/routed-dialog/routed-dialog.module';
import { ConnectorPillComponent } from './connector-pill/connector-pill.component';

@NgModule({
    declarations: [ConnectorBadgeComponent, ConnectorPillComponent],
    imports: [
        CommonModule,
        MatIconModule,
        ConnectorStatusPipesModule,
        CustomerPrivacyModule,
        RouterModule,
        RoutedDialogWrapperModule,
    ],
    exports: [ConnectorBadgeComponent, ConnectorPillComponent],
})
export class ConnectorBadgeModule {}
